<template>
    <section class="terms col-12">
        <div style="text-align: center">
            <img
                src="https://app.planejadordetreino.com/images/logo.jpg"
                style="width: 90%"
            />
            <h1 class="py-4">Termos de Uso</h1>
        </div>

        <p>
            Ao acessar e utilizar o Planejador de Treino, o usuário declara que
            leu, compreendeu e concorda com os presentes Termos de Uso.
        </p>

        <h4>1. Descrição do serviço</h4>
        <p>
            O Planejador de Treino é uma plataforma online destinada à criação,
            organização e gestão de treinos, exercícios, conteúdos esportivos e
            materiais relacionados, podendo incluir funcionalidades baseadas em
            Inteligência Artificial.
        </p>

        <h4>2. Cadastro e acesso</h4>
        <p>
            O acesso à plataforma exige cadastro com e-mail e senha. O número de
            telefone solicitado no cadastro é utilizado exclusivamente para
            contato com o suporte.
        </p>

        <p>
            O usuário é responsável por manter a confidencialidade de suas
            credenciais de acesso.
        </p>

        <h4>3. Planos, pagamentos e reembolso</h4>
        <p>
            Os planos disponíveis, valores, condições de pagamento, política de
            cancelamento e reembolso estão descritos na página inicial da
            plataforma.
        </p>

        <p>
            Não há plano totalmente gratuito. O usuário pode testar o serviço
            por até 7 (sete) dias e, caso não fique satisfeito, solicitar o
            reembolso integral dentro desse período.
        </p>

        <h4>4. Responsabilidades do usuário</h4>
        <p>
            O usuário é integralmente responsável por todo o conteúdo que
            inserir na plataforma.
        </p>

        <ul>
            <li>
                Exclusões acidentais de dados são de responsabilidade exclusiva
                do usuário
            </li>
            <li>
                Problemas de conexão, internet ou ambiente incompatível não são
                de responsabilidade da plataforma
            </li>
            <li>
                O usuário é responsável por manter seus dados pessoais
                protegidos
            </li>
            <li>O acesso à plataforma depende de conexão com a internet</li>
        </ul>

        <h4>5. Inteligência Artificial</h4>
        <p>
            As funcionalidades baseadas em Inteligência Artificial podem gerar
            treinos ou conteúdos que não sejam totalmente consistentes.
        </p>

        <p>
            O usuário reconhece que deve sempre revisar e validar os conteúdos
            gerados antes de utilizá-los.
        </p>

        <h4>6. Propriedade intelectual</h4>
        <p>
            A plataforma, sua interface, marca, código, textos e funcionalidades
            são protegidos por direitos de propriedade intelectual.
        </p>

        <p>
            É proibida qualquer tentativa de clonagem, exploração indevida,
            engenharia reversa ou uso não autorizado do sistema.
        </p>

        <h4>7. Penalidades</h4>
        <p>
            Tentativas de uso indevido, violação de segurança ou clonagem da
            plataforma poderão resultar em suspensão da conta e
            responsabilização legal.
        </p>

        <h4>8. Encerramento de conta</h4>
        <p>
            O usuário pode excluir sua conta a qualquer momento ou solicitar a
            remoção de seus dados por meio dos canais de suporte.
        </p>

        <h4>9. Limitação de responsabilidade</h4>
        <p>O Planejador de Treino não se responsabiliza por:</p>

        <ul>
            <li>Danos decorrentes do uso indevido da plataforma</li>
            <li>Indisponibilidade causada por falhas externas</li>
            <li>Perda de dados causada por ação do próprio usuário</li>
        </ul>

        <h4>10. Contato</h4>
        <p>Para dúvidas ou solicitações, entre em contato através de:</p>

        <ul>
            <li>E-mail: paulo_junior.95@hotmail.com</li>
            <li>
                WhatsApp:
                <a href="https://api.whatsapp.com/message/567MNUG3EA6JA1"
                    >https://api.whatsapp.com/message/567MNUG3EA6JA1</a
                >
            </li>
        </ul>

        <p>
            Estes Termos de Uso podem ser atualizados a qualquer momento. O uso
            contínuo da plataforma implica aceitação das versões atualizadas.
        </p>

        <div class="pa-4 bg-white">
            <p style="text-align: center">
                PAULO HENRIQUE MARQUES JUNIOR<br />CNPJ: 37.051.662/0001-09<br />JOINVILLE
                – SC<br />EMAIL: paulo_junior.95@hotmail.com
            </p>
        </div>
    </section>
</template>

<script>
export default {
    name: "TermsView",
    created() {
        document.body.classList.add("login-page");
        document.title = "Termos de uso - planejador de treinos";
    },
};
</script>

<style scoped lang="scss">
section {
    h1,
    h4 {
        font-weight: bolder;
    }
}
</style>
